import { Record } from 'immutable';
import { DEFAULT_KEY_ORDER } from 'commons-vehicle/constants/dataTypes.js';

const FeatureIconRecord = Record({
    code: '',
    description: '',
    rank: DEFAULT_KEY_ORDER,
    isFromModelTrim: true,
    modelTrimRank: DEFAULT_KEY_ORDER,
});

class FeatureIcon extends FeatureIconRecord {}

export default FeatureIcon;
